import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {
  Company,
  Country,
  Currency, DocumentType,
  EquipmentType,
  EventType,
  FeeType,
  GetParams, LocationType,
  Partner,
  PartnerType,
  State,
  UserRole
} from '@app/shared';
import {
  CurrencyService,
  DocumentService,
  EquipmentService,
  FeeService,
  FlowEventService,
  LocationTransportService,
  PartnerService,
  UserService
} from '@app/core';


@Injectable
({
  providedIn: 'root'
})

export class MaestrosUtilsService {

  detailsDrawerRef$: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);

  loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  secondaryLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  drawerRef$: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
  getParams: GetParams = {
    startRow: 0,
    endRow: 100,
    sortDirection: 'asc',
    sortProperty: 'id',
  }

  constructor() {
  }

  set drawerRef(value: any) {
    this.drawerRef$.next(value);
  }

  get loading(): Observable<boolean> {
    return this.loading$ as Observable<boolean>;
  }

  set loading(value: boolean) {
    this.loading$.next(value);
  }

  get drawerRef() {
    return this.drawerRef$ as Observable<any>
  }

  get detailsDrawerRef() {
    return this.detailsDrawerRef$ as Observable<any>
  }

  set detailsDrawerRef(value: any) {
    this.detailsDrawerRef$.next(value);
  }

















}
